// src/api/contactApi.js
import { contactMockData } from "./mock/contactData";

// PASTIKAN ADA KATA 'export' DI DEPAN CONST
export const getContactData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(contactMockData);
    }, 500);
  });
};